import $ from "jquery";
import apiFetch from "@wordpress/api-fetch";
import { reloadScriptPostCard } from "./post-card";
import {
  reloadScriptActions,
  reloadScriptCommentEdit,
} from "./comment-actions";
import { reloadScriptComment } from "./comment";
import { reloadScriptPostLikeButton } from "./post-like-button";
import { reloadScriptPostActions } from "./post-actions";
import { smoothscroll } from "../utils/smoothscroll";
import Cookies from "js-cookie";

const $pageBody = $(".page__body");

const homepage = function () {
  const homepage = $(this);
  const homepagePosts = $(this).find(".homepage__posts");

  const filter = {
    type: "all",
    showId: null,
    page: 1,
    limit: 10,
  };

  bindNav(homepagePosts, filter);
  bindTabs(homepage);
  bindScroll(homepagePosts.get(0), filter);
  bindShows(homepage, filter);
  bindPortfolio(homepage);
  
  const cookieHidePortfolio = Cookies.get("portfolio");  
  if (cookieHidePortfolio == 'true') {
    homepage.find("[data-portfolio-hide]")
      .toggleClass("homepage__left-hide--hidden");

    homepage.find(".homepage__left-value")
      .toggleClass("homepage__left-value--hidden");
  }

};

const bindNav = (el, filter) => {
  el.off("click", ".homepage__posts-nav > button");
  el.on("click", ".homepage__posts-nav > button", function () {
    const button = $(this);
    filter.type = button.data("type");
    filter.page = 1;
    reRenderPosts(el.get(0), filter);

    el.find(".company__tab-switcher--active").removeClass(
      "company__tab-switcher--active"
    );
    button.addClass("company__tab-switcher--active");
  });
};

const bindTabs = (el) => {
  el.off("click", "[data-tab-button]");
  el.on("click", "[data-tab-button]", function () {
    const $thisEL = $(this).parent();
    const id = $thisEL.attr("data-id");

    el.find("[data-hp-tab]").attr("data-selected", "false");
    el.find(`[data-hp-tab][data-id="${id}"]`).attr("data-selected", "true");

    smoothscroll(0, 0, 0);
  });
};

const bindShows = (el, filter) => {
  const deactivateAllButtons = () => {
    el.find("[data-homepage-show][active='true']")
      .attr("active", false)
      .filter(function () {
        return $(this).hasClass("homepage__show-button");
      })
      .html("Zobrazit");
    el.find("[data-homepage-show][active='true']")
      .closest(".homepage__show")
      .removeClass("homepage__show--active");
  };

  el.off("click", "[data-homepage-show]");
  el.on("click", "[data-homepage-show]", function () {
    const button = $(this);

    filter.page = 1;
    if (button.attr("active") === "true") {
      deactivateAllButtons();

      filter.showId = null;
      filter.type = "all";

      el.find(".homepage__posts-nav").show();
      el.find(".homepage__show-banner").hide();
    } else {
      deactivateAllButtons();

      filter.showId = button.data("id");
      filter.type = "show";

      el.find(`[data-homepage-show][data-id=${filter.showId}]`)
        .attr("active", true)
        .filter(function () {
          return $(this).hasClass("homepage__show-button");
        })
        .html("Skrýt");

      el.find(".homepage__posts-nav").hide();
      el.find(".homepage__show-banner")
        .css("display", "flex")
        .children("h1")
        .html(
          button
            .closest(".homepage__show")
            .find(".post-card__company-name")
            .html()
        );

      button.closest(".homepage__show").addClass("homepage__show--active");

      el.find("[data-hp-tab], [data-tab-item]").attr("data-selected", "false");
      el.find(
        `[data-hp-tab][data-id="hp-posts"], [data-tab-item][data-id="hp-posts"]`
      ).attr("data-selected", "true");
    }
    reRenderPosts(el.get(0), filter);
  });

  el.off("click", ".homepage__show-close");
  el.on("click", ".homepage__show-close", function () {
    el.find(".homepage__posts-nav").show();
    el.find(".homepage__show-banner").hide();

    deactivateAllButtons();

    filter.page = 1;
    filter.showId = null;
    filter.type = "all";

    reRenderPosts(el.get(0), filter);
  });
};

const bindScroll = (el, filter) => {
  const options = {
    root: document.querySelector(".page__body"),
  };

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.disconnect();
        filter.page += 1;
        appendPosts(el, filter);
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);
  const lazyElems = el.querySelectorAll(".posts-lazy");

  if (lazyElems.length) {
    observer.observe(...lazyElems);
  }
};

const bindPortfolio = (el) => {
  el.off("click", "[data-portfolio-hide]");
  el.on("click", "[data-portfolio-hide]", function () {
    const button = $(this);
    
    button.addClass("homepage__left-hide--hidden");
    button.siblings("[data-portfolio-hide]")
      .removeClass("homepage__left-hide--hidden");

    el.find(".homepage__left-value")
      .toggleClass("homepage__left-value--hidden");

    if(Cookies.get("portfolio") == 'true'){
      Cookies.set("portfolio", 'false', { expires: 1 });
    } else {
      Cookies.set("portfolio", 'true', { expires: 1 });
    }
  });
}

const reRenderPosts = async (el, filter) => {
  const $el = $(el);
  const loader = $el.find(".homepage__posts-loader");
  const content = $el.find("#posts-content");

  $pageBody.scrollTop(0);
  loader.show();
  content.html("");

  try {
    const newPosts = await getPosts(filter);

    loader.hide();

    content.html(newPosts.html);
    reloadScriptPostCard();
    reloadScriptComment();
    reloadScriptActions();
    reloadScriptCommentEdit();
    reloadScriptPostLikeButton();
    reloadScriptPostActions();

    if (newPosts?.count) {
      bindScroll(el, filter);
    }
  } catch (e) {
    console.error(e);
  }
};

const appendPosts = async (el, filter) => {
  const $el = $(el);
  const content = $el.find("#posts-content");

  try {
    const newPosts = await getPosts(filter);

    content.find(".posts-lazy").remove();

    content.append(newPosts.html);
    reloadScriptPostCard();
    reloadScriptComment();
    reloadScriptActions();
    reloadScriptCommentEdit();
    reloadScriptPostLikeButton();
    reloadScriptPostActions();

    if (newPosts?.count) {
      bindScroll(el, filter);
    }
  } catch (e) {
    console.error(e);
  }
};

const getPosts = async (filter) => {
  return await apiFetch({
    path: "/xixoio/v1/post-insight/html",
    method: "POST",
    data: filter,
  });
};

export const reloadScriptHomepage = () => $(".homepage").each(homepage);
reloadScriptHomepage();
